/**
 * Created by Ning Jiang on 2024-01-19.
 */

import {DeadwoodRipSymbol} from "./DeadwoodRipSymbol";
import {DeadwoodRipSymbolState} from "./DeadwoodRipSymbolConfig";
import {gsap, TimelineLite} from "gsap";
import {DeadwoodRipSound} from "../sound/DeadwoodRipSound";
import {DeadwoodRip} from "../DeadwoodRip";
import {MultiSprites} from "@nolimitcity/slot-game/bin/animation/MultiSprites";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";

export class DeadwoodRipReelSplitSymbol extends DeadwoodRipSymbol {

    constructor(reelId:number, initState:DeadwoodRipSymbolState) {
        super("WRS", reelId, initState);
    }

    public playOnShot():TimelineLite {
        const tl = new TimelineLite();
        tl.add(() => {
            Logger.logDev(`I am ${this._itemName}, I play on shot!`);
        });
        return tl;
    }

    protected getOnShotAnimationName():string {
        return `WRS_Shoot`;
    }

    protected getDeadLoopAnimationName():string {
        return `WRSDeadLoop`;
    }

    protected getCharacterAssetName():string {
        return "WRS";
    }

    public playLanding(init:boolean = false):TimelineLite {
        this.createDeadContainer();
        const tl = new TimelineLite();
        tl.add(() => {
            this._deadCharacter.visible = true;
            this._deadCharacter.state.setAnimation(1, "WRSLanding", false);
        });

        tl.add(() => {
        }, `+=${this._deadCharacter.spineData.findAnimation("WRSLanding").duration}`);
        tl.add(this.showWild(), `-=0.2`);
        return tl;
    }

    public showWild():TimelineLite {
        if(!this._partPatchContainer) {
            this._partPatchContainer = new PIXI.Container();
            this.updateLayers();
        }
        const w = new PIXI.Sprite(DeadwoodRip.assetLoader.getTextures(`WILD/WILD`)[0]);
        w.anchor.set(0.5);
        w.alpha = 0;
        this._partPatchContainer.addChild(w);
        this._partPatches.push(w);

        const tl = new TimelineLite();
        tl.add([
            gsap.to(w, {duration : 0.18, alpha : 1}),
            gsap.fromTo(w.scale, {x : 1.2, y : 1.2}, {duration : 0.18, x : 1, y : 1})
        ]);
        return tl;
    }

    protected addSplitPartOverlay(part:MultiSprites):void {
        const w = new PIXI.Sprite(DeadwoodRip.assetLoader.getTextures(`WILD/WILD`)[0]);
        w.anchor.set(0.5);
        w.position.set(part.x, part.y);
        const scale = this.symbolSize == 4 ? 0.6 : (this.symbolSize == 2 ? 0.9 : 1);
        w.scale.set(scale);
        this._partPatchContainer.addChild(w);
        this._partPatches.push(w);
    }

    protected playKill():TimelineLite {
        const tl = super.playKill();
        tl.add(() => {
            this._parts.forEach(p => {
                gsap.to(p, {alpha : 1, duration : 0.3});
            });
        }, `-=0.3`);
        return tl;
    }

    public playIndividualKill():TimelineLite {
        const tl = super.playIndividualKill();
        tl.add(() => {
            if(!this.removed) {
                this._parts.forEach(p => {
                    gsap.to(p, {alpha : 1, duration : 0.3});
                });
            }
        }, `-=0.3`);

        return tl;
    }

    protected playKillSound():void {
        DeadwoodRipSound.playSymbolKill("WRS", this.reelId);
    }
}